export default __webpack_public_path__ + "136bc2e52933a5f4082f3cf2b011f9af.png";